class ConstFasesEntrega
{
  SalidaAlmacen = 1;
  LlegadaAduana = 2;
  SalidaAduana = 3;
  LlegadaReten = 4;
  SalidaReten = 5;
  LlegadaPuerto = 6;
  LiberacionPuerto = 7;
  Zarpe = 8;
  LlegadaPuertoDestino = 9;
  LlegadaDestinoFinal = 10;
  Entregada = 11;
  Rechazada = 12;
  vals = {
    1: "salidaAlmacen",
    2: "customsArrive",
    3: "customsDeparture",
    4: "llegadaReten",
    5: "salidaReten",
    6: "porArrival",
    7: "portDeparture",
    8: "setSail",
    9: "llegadaPuertoDestino",
    10: "llegadaDestinoFinal",
    11: "delivered",
    12: "rejected"
  };
  constructor(obj = {}) {
    Object.assign(this, obj);
  }
  getValue(tipo){
    return this.vals[tipo];
  }
}

module.exports = ConstFasesEntrega;
